import { Close } from '@mui/icons-material'
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { lighten } from '@mui/material/styles'

// Reused by the 3 hand-rolled Investment admin tables (Transfers, Portfolios,
// Value Adjustments -- none of them are on react-admin's List/Datagrid, so
// they don't get DatagridWithSelectAll's built-in RaBulkActionsToolbar for
// free) to match /GrantRequest's row-selection pattern: the normal
// Create/Export/Column-Settings action row is replaced by this bar the
// moment any row is checked, showing the selection count and the bulk
// action(s) available for it. Styling mirrors react-admin's own
// BulkActionsToolbar (node_modules/ra-ui-materialui/src/list/
// BulkActionsToolbar.tsx) EXACTLY AS IT ACTUALLY RENDERS on /GrantRequest --
// a light-mode primary-tinted background, not this app's own theme override
// in management/index.jsx's `.RaBulkActionsToolbar-toolbar` block, which
// LOOKS like it forces a plain paper background but is dead code: it writes
// `backgroundColor: 'background.paper !important'` as one sx string, and
// MUI's sx system only resolves a bare theme-palette-path string like
// 'background.paper' -- appending ' !important' inside the string itself
// makes the whole value fail that lookup and fall through to being used
// verbatim as a literal (invalid) CSS value, which the browser drops. So
// react-admin's own un-overridden background is what's actually showing.
// Height, top-corners-only radius, and the left-aligned unselect icon button
// are also react-admin's own defaults (untouched by that override either
// way). Sticky positioning IS a real, working part of that override --
// position/top/zIndex/transform aren't palette-path props, so they don't hit
// this bug. `label`/`clearLabel` are passed in already translated -- this
// component has no feature of its own to hang an i18n namespace off of, so
// each caller supplies its own via useTranslate(). `clearLabel` becomes the
// unselect button's accessible name/tooltip, not visible text, matching
// react-admin's own icon-only convention.
export function SelectionActionsBar({ label, onClear, clearLabel, children }) {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        color: (theme) => (theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.text.primary),
        bgcolor: (theme) =>
          theme.palette.mode === 'light' ? lighten(theme.palette.primary.light, 0.8) : theme.palette.primary.dark,
        borderTopLeftRadius: (theme) => theme.shape.borderRadius,
        borderTopRightRadius: (theme) => theme.shape.borderRadius,
        px: 2,
        minHeight: (theme) => theme.spacing(6),
        position: 'sticky',
        top: 0,
        zIndex: 1200,
      }}
    >
      {onClear && (
        <Tooltip title={clearLabel}>
          <IconButton size="small" onClick={onClear} aria-label={clearLabel} color="inherit" sx={{ ml: -1 }}>
            <Close fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      <Typography color="inherit" variant="subtitle1" sx={{ flexShrink: 0 }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1 }} />
      {children}
    </Stack>
  )
}
